export const PERSON_ROLE_USER = 100;
export const PERSON_ROLE_ADMIN = 200;
export const PERSON_ROLE_PENDING_OWNER = 250;
export const PERSON_ROLE_OWNER = 300;

export const ADMIN_TYPE_PENDING_OWNER = 'Owner (pending)';
export const ADMIN_TYPE_OWNER = 'Owner';
